/**
 * Default {@link BatchRunner} backing the Batch UI: spawns the batch Web Worker,
 * relays per-file progress, and resolves with all results. A fresh worker is
 * created per run and terminated on completion so no thread lingers. Tests inject
 * the in-process `runBatch` instead, so this worker glue is covered by e2e.
 */
import type { BatchResponse } from '../workers/batch.worker';
import type { BatchRunner } from './types';

export const workerRunner: BatchRunner = (inputs, job, onProgress) =>
  new Promise((resolve, reject) => {
    const worker = new Worker(new URL('../workers/batch.worker.ts', import.meta.url), {
      type: 'module',
    });
    worker.onmessage = (e: MessageEvent<BatchResponse>) => {
      const msg = e.data;
      if (msg.type === 'progress') {
        onProgress?.(msg.done, msg.total, msg.result);
      } else {
        worker.terminate();
        resolve(msg.results);
      }
    };
    worker.onerror = (err) => {
      worker.terminate();
      reject(new Error(err.message || 'Batch worker failed'));
    };
    worker.postMessage({ inputs, job });
  });
